export default "__VITE_ASSET__0a831586__"